import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import { AuthContext } from '../../context/AuthContext';
import useUser from '../../context/hooks/useUser';

import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { FormaPagamentoType, UpdateFormaPagamentoType } from '../../context/hooks/useFormaPagamento';

import { CreateFormaPagamentoModal } from '../../components/FormaPagamento/CreateFormaPagamentoModal';
import { EditFormaPagamentoModal } from '../../components/FormaPagamento/EditFormaPagamentoModal';

const ContaPagar = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listFormaPagamento, formaPagamentoPageCount, getAllFormaPagamentoPaged, deleteFormaPagamento } = useContext(FormaPagamentoContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [editingFormaPagamento, setEditingFormaPagamento] = useState<UpdateFormaPagamentoType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);

        getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar formas de pagamento:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllFormaPagamentoPaged(value, pageSize, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditFormaPagamento = (formaPagamento: FormaPagamentoType) => {
        setEditingFormaPagamento(formaPagamento);
        setEditModalOpen(true);
    };

    const handleDeleteFormaPagamento = (formaPagamentoId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta forma de pagamento?")) {
            deleteFormaPagamento(formaPagamentoId)
                .then(deletedFormaPagamento => {
                    if (deletedFormaPagamento) {
                        getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir forma de pagamento.");
                    }
                    getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir forma de pagamento:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Forma de pagamento"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar forma de pagamento
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Forma de pagamento</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listFormaPagamento.map((formaPagamento: FormaPagamentoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{formaPagamento.id}</td>
                                                <td>{formaPagamento.name}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditFormaPagamento(formaPagamento) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteFormaPagamento(formaPagamento.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {/* <div className="d-flex justify-content-end mt-3">
                                {formaPagamentoPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={formaPagamentoPageCount}
                                        />
                                    </div>
                                )}
                                {listFormaPagamento.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllFormaPagamentoPaged(1, newSize, objUserTk.EmpresaId);
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {formaPagamentoPageCount > 1 && (
                                    <div className="d-flex justify-content-end">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={formaPagamentoPageCount}
                                        />
                                    </div>
                                )}
                            </div>

                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as formas de pagamento.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateFormaPagamentoModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId)}
            />

            <EditFormaPagamentoModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                formaPagamento={editingFormaPagamento}
                onUpdated={() => getAllFormaPagamentoPaged(1, pageSize, objUserTk.EmpresaId)}
            />
        </>
    );
};

export default ContaPagar;